module.exports = __webpack_public_path__ + "static/media/atomlogo.ae0278b8.jpg";